module.exports = __webpack_public_path__ + "media/images/pear_3-16758644d426433d795ef608c9d3d944.jpg";